import React, { HTMLAttributes, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//const { useTranslation } = Hooks;
//import store from "store";
import styles from "./index.module.scss";
export enum SortStates {
  default = "default",
  desc = "desc",
  asc = "asc",
}
interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  /**每一列的属性名 */
  prop?: string;
  /**当前的一列 */
  isme?: string;
  /**排序改变事件 */
  onSort?(prop?: string, sort?: SortStates): void;
  children?: React.ReactNode;
}
const Sort: React.FC<Props> = ({ className = "", prop, isme, onSort, children }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  // useState
  const [sortIndex, setSortIndex] = useState(0);
  const [sortStates, setSortStates] = useState(["default", "desc", "asc"] as SortStates[]); // 默认, 降序，升序
  const [flag, setFlag] = useState(true); // true当前列表排序， false其它列排序，当前列排序状态置灰
  // useEffect
  useEffect(() => {
    setFlag(prop === isme);
  }, [isme]);

  useEffect(() => {
    !flag && setSortIndex(0);
  }, [flag]);
  // useMemo
  const getSortClass = useMemo(() => {
    if (!flag) return "";
    return sortStates[sortIndex];
  }, [flag, sortStates, sortIndex]);

  // method
  const onSortChange = () => {
    const index = sortIndex + 1;
    index > 2 && setSortIndex(0);
    onSort && onSort(prop, sortStates[sortIndex]);
  };

  return (
    <button className={cx(styles["sort-btntxt"], styles[getSortClass])} onClick={onSortChange}>
      {children}
    </button>
  );
};
export default observer(Sort);
